module.exports = __webpack_public_path__ + "img/upper-pavilion.512d28ad.svg";